import axios, { AxiosRequestConfig } from 'axios';

const apiUrl = process.env.REACT_APP_BACKEND_API_URL;

export interface User {
  last_name: string;
  first_name: string;
  email: string;
  postcode: string;
  prefecture: string;
  city: string;
  building: string;
  phone_number: string;
  tickets: number;
}

export const getCurrentUser = async (config?: AxiosRequestConfig): Promise<User> => {
  // 現在のユーザーのデータを取得
  const response = await axios.get(`${apiUrl}/currentUser/`, { withCredentials: true, ...config });
  return response.data;
}

export interface UpdateUserValues {
  postcode: string;
  prefecture: string;
  city: string;
  building: string;
  phone_number: string;
}

// マイページ 登録情報(住所・郵便番号・電話番号)の変更
export const updateUser = async (values: UpdateUserValues): Promise<User> => {
  const response = await axios.post(`${apiUrl}/updateUser/`, values, { withCredentials: true });
  return response.data;
}

// マイページ メールアドレス変更申請(新しいアドレス宛に確認メールが送られる)
export const requestEmailChange = async (email: string): Promise<void> => {
  await axios.post(`${apiUrl}/email_change/`, { email: email }, { withCredentials: true });
}

// メール内のURLからのメールアドレス変更確定。ログイン状態を問わずトークンのみで実行する
export const confirmEmailChange = async (token: string): Promise<void> => {
  await axios.post(`${apiUrl}/email_change_confirm/`, { token: token }, { withCredentials: true });
}
